<template>
  <div class="mall_wrap">
    <Nav :subNav="'小宝商城'" :isShowBack="1"></Nav>
    <div class="mall_left_wrap">
      <div class="exchange">
        <div class="exchange_nav">
          <div
            @click="changeCategory(item.value)"
            :class="{
              exchange_nav_item: true,
              active: item.value == category ? true : false,
            }"
            :key="item.value"
            v-for="item in categorys"
          >
            <div class="exchange_nav_item_title">
              {{ item.name }}
            </div>
            <div class="exchange_nav_item_line"></div>
          </div>
        </div>
        <div class="exchange_list_wrap" id="exchange_list_wrap">
          <div class="exchange-tips" v-if="false">
            积分商城于
            <font style="font-weight: bolder">2月7日-2月15日</font>
            进行维护。<br />
            兑换功能暂时关闭，敬请谅解。
          </div>
          <div
            class="exchange_list"
            :id="category.value"
            :key="category.value"
            v-for="category in categorys"
          >
            <div class="exchange_list_title">
              <div class="exchange_list_title_icon"></div>
              <div class="exchange_list_title_text">
                {{ category.listName }}
              </div>
            </div>
            <ul>
              <li
                @click="showExchangeAlert(goods.gid)"
                :key="goods.gid"
                v-for="goods in category.list"
              >
                <div class="exchange_list_item_img_wrap">
                  <div class="exchange_list_item_img">
                    <img :src="goods.large_img" />
                  </div>
                </div>
                <div class="exchange_list_item_bottom_wrap">
                  <div class="exchange_list_item_name">
                    {{ goods.name }}
                  </div>
                  <div class="exchange_list_item_points">
                    {{ goods.points }} <span>积分</span>
                  </div>
                  <div
                    class="exchange_btn"
                    @click="showExchangeAlert(goods.gid)"
                  >
                    兑换
                  </div>
                </div>
                <div class="exchange_left_line"></div>
              </li>
            </ul>
          </div>
        </div>
        <ExchangeAlert
          :goods="exchangeGoods"
          @close="onExchangeClose"
          v-if="isShowExchangeAlert"
        ></ExchangeAlert>
        <div class="exchange_tips_alert" v-if="isShowErrTips">
          <div class="exchange_tips_alert_body">
            抱歉，当前积分不足以兑换该商品
          </div>
        </div>

        <!--  未登录用户不能兑换会员卡  -->
        <div class="alert_wechat" v-if="isShowWechatTips">
          <div class="box_wechat">
            <div class="box_tips_horn">
              <img :src="exchange_tips_horn" class="tips_horn" />
              <span class="text1">兑换会员卡</span>
            </div>
            <div class="text2">请到微信小程序【节点小宝】</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mall_right_wrap">
      <JdbRank class="jdb_rank"></JdbRank>
    </div>
  </div>
</template>

<script>
import ExchangeAlert from "@/components/ExchangeAlert.vue";
import JdbRank from "@/components/JdbRank.vue";
import Nav from "@/components/Common/Nav.vue";
import { mapActions } from "vuex";

export default {
  name: "exchange",
  data: function () {
    return {
      isShowExchangeAlert: false,
      isScrollLock: false,
      category: "video",
      categoryName: "",
      isShowPointsRulesAlert: false,
      home_user_unlogin_avatar: require("../assets/mall/home_user_unlogin_avatar.png"),
      list: [],
      categoryList: [],
      exchangeGoods: {},
      isShowErrTips: false,
      isShowWechatTips: false,
      isShowSettingAlert: false,
      categorys: [
        {
          name: "视频",
          listName: "视频会员",
          value: "video",
          list: [],
        },
        {
          name: "音乐",
          listName: "音乐会员",
          value: "music",
          list: [],
        },
        {
          name: "云盘",
          listName: "云盘下载",
          value: "download",
          list: [],
        },
        {
          name: "话费",
          listName: "话费充值",
          value: "phone",
          list: [],
        },
      ],
    };
  },
  components: {
    ExchangeAlert,
    JdbRank,
    Nav,
  },
  watch: {
    isShowErrTips: function (newVal) {
      let _that = this;
      if (newVal) {
        setTimeout(function () {
          _that.isShowErrTips = false;
        }, 1500);
      }
    },

    isShowWechatTips: function (newVal) {
      let _that = this;
      if (newVal) {
        setTimeout(function () {
          _that.isShowWechatTips = false;
        }, 1500);
      }
    },
  },
  methods: {
    ...mapActions([
      "getGoodsList",
      "getUserInfo",
      "getUserPoints",
      "sendUserlog",
    ]),

    onExchangeClose: function () {
      this.isShowExchangeAlert = false;
    },
    changeCategory: function (category) {
      let _that = this;
      this.category = category;
      for (let index = 0; index < this.categorys.length; index++) {
        const element = this.categorys[index];
        if (element.value == category) {
          this.categoryName = element.name;
        }
      }
      document.getElementById(category).scrollIntoView();
      this.categoryList = [];
      for (let index = 0; index < this.list.length; index++) {
        const element = this.list[index];
        if (element.category == category) {
          this.categoryList.push(element);
        }
      }
      // 禁止scroll滚动导致导航栏不准确
      _that.isScrollLock = true;
      setTimeout(function () {
        _that.isScrollLock = false;
      }, 100);
    },
    // //使用pid、product、以及海康或铁威马的标识，去获取绑定码
    showActiveCode: function () {
      let _that = this;
      _that.$store.state.isShowActiveCodeAlert = true;
    },
    showPointsRules: function () {
      let _that = this;
      _that.isShowPointsRulesAlert = !_that.isShowPointsRulesAlert;
    },

    showSetting: function () {
      let _that = this;

      let uid = _that.$store.state.user.uid;
      let pid = _that.$store.state.device.pid;
      if (uid != "" && pid == "") {
        //如果从小程序进来，没有绑定的话，提示请绑定设备
        _that.$weui.toast("请绑定设备", {
          duration: 1000,
          className: "weui-toast-text",
        });
        return;
      }
      _that.isShowSettingAlert = true;
    },
    goBack: function () {
      this.$router.back(-1);
    },
    showAbout: function () {
      let _that = this;
      _that.$store.state.isShowAbout = true;
    },
    goHistory: function () {
      let _that = this;

      //有uid，表示已经登录，有sn，识别从海康进入，此时显示去微信小程序进入兑换的浮层
      let from = _that.$store.state.from;
      if (from == "HiKNas") {
        _that.isShowWechatTips = true;
        return;
      }

      _that.$router.push({ path: "/history" });
    },
    goAbout: function () {
      let _that = this;
      _that.$router.push({ path: "/about" });
    },
    showExchangeAlert: function (gid) {
      let _that = this;

      _that.sendUserlog(["mall_exchange_click", ""]);

      let uid = _that.$store.state.user.uid;
      let sn = _that.$store.state.sn;

      //海康进入，此时显示去微信小程序进入兑换的浮层
      let from = _that.$store.state.from;
      if ((from == "HiKNas" || from == "LenvNas") && uid && sn) {
        _that.isShowWechatTips = true;
        return;
      } else if ((from == "HiKNas" || from == "LenvNas") && uid == "" && sn) {
        //  没有uid，表示没有登录，但是有sn，此时显示绑定码页面
        _that.$store.state.isShowActiveCodeAlert = true;
        return;
      }

      for (let index = 0; index < _that.list.length; index++) {
        const item = _that.list[index];
        if (gid == item.gid) {
          _that.exchangeGoods = item;
        }
      }
      // console.log(
      // 	_that.$store.state.user.left_points,
      // 	_that.exchangeGoods.points
      // );
      if (_that.$store.state.user.left_points < _that.exchangeGoods.points) {
        _that.isShowErrTips = true;
      } else {
        this.isShowExchangeAlert = true;
      }
    },
    getList: function () {
      let _that = this;
      this.getGoodsList([
        "",
        function (err, data) {
          if (err) {
            return console.log(err);
          }

          _that.list = data.data;
          _that.buildCategoryList();
        },
      ]);
    },
    buildCategoryList: function () {
      let _that = this;
      for (let index = 0; index < _that.list.length; index++) {
        const element = _that.list[index];
        for (let j = 0; j < _that.categorys.length; j++) {
          const category = _that.categorys[j];
          if (element.category == category.value) {
            category.list.push(element);
            break;
          }
        }
      }

      for (let i = _that.categorys.length - 1; i >= 0; i--) {
        let category = _that.categorys[i];
        if (category.list.length <= 0) {
          _that.categorys.splice(i, 1);
        }
      }
    },
    scroll: function () {
      let _that = this;
      // 滚动锁
      if (_that.isScrollLock) {
        return;
      }
      let parentOffsetTop =
        document.getElementById("exchange_list_wrap").offsetTop;
      let parentHeight =
        document.getElementById("exchange_list_wrap").clientHeight;
      let offsetTops = [];
      let listEles = document.getElementsByClassName("exchange_list");
      for (let index = 0; index < listEles.length; index++) {
        const element = listEles[index];
        offsetTops.push(element.offsetTop - parentOffsetTop);
      }
      const scrollTop = document.getElementById("exchange_list_wrap").scrollTop;
      for (let index = offsetTops.length - 1; index >= 0; index--) {
        const element = offsetTops[index];
        // 判断子栏目是否出现在页面
        if (scrollTop + parentHeight - 30 > element) {
          let category = _that.categorys[index];
          _that.category = category.value;
          _that.categoryName = category.name;
          break;
        }
      }
    },
    hideSettingAlert: function () {
      this.isShowSettingAlert = false;
    },
    getUserPointsInfo: function () {
      let _that = this;
      let reqData = {
        count: 7,
        uid: _that.$store.state.user.uid,
      };
      _that.getUserInfo([reqData]);
      _that.getUserPoints([
        reqData,
        function (err, data) {
          if (err) {
            return;
          }
          if (data.data) {
            for (let index = data.data.length - 1; index >= 0; index--) {
              const element = data.data[index];
              _that.$store.state.user.last_points = element.points;
            }
          }
        },
      ]);
    },
  },
  mounted: function () {
    let _that = this;
    _that.getList();
    _that.getUserPointsInfo();
    _that.sendUserlog(["open_mall", ""]);
    document
      .getElementById("exchange_list_wrap")
      .addEventListener("scroll", _that.scroll);
  },
};
</script>

<style lang="less" scoped>
.mall_wrap {
  width: 960px;
  height: 550px;
  background-color: #f5f5f5;
  text-align: left;
  position: relative;
  .mall_left_wrap {
    width: 655px;
    height: 500px;
    display: inline-block;
    vertical-align: top;
    margin-left: 9px;
    border: 1px solid #4366b5;
    border-radius: 2px;
    overflow: hidden;
    background-color: #f1f4fb;
  }
  .mall_right_wrap {
    width: 275px;
    height: 500px;
    display: inline-block;
    vertical-align: top;
    margin-left: 8px;
    border: 1px solid #4366b5;
    border-radius: 4px;
    .jdb_rank {
    }
  }
}

.exchange {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: relative;
  flex-direction: column;

  .alert_wechat {
    width: 100%;
    height: 100%;
    z-index: 9;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);

    .box_wechat {
      position: absolute;
      text-align: center;
      box-sizing: border-box;
      padding-top: 26px;
      padding-bottom: 31px;
      background-color: #fefdf8;
      border-radius: 10px;
      transform: translate(-50%, 200%);
      margin-left: 50%;

      .box_tips_horn {
        .tips_horn {
          width: 15px;
          height: 12px;
        }

        .text1 {
          color: #333333;
          font-size: 15px;
        }
      }

      .text2 {
        margin-top: 18px;
        width: 233px;
        color: #666666;
        font-size: 14px;
      }
    }
  }

  .home_top {
    position: relative;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;

    .box_set {
      position: absolute;
      right: 3%;
      top: 3px;
      padding: 6px;

      .set_icon {
        width: 21px;
        height: 21px;
      }
    }

    .box_set:hover {
      opacity: 0.9;
      cursor: pointer;
    }

    .home_user {
      display: inline-block;
      margin-left: 35px;
      margin-top: 7px;
      .home_user_avatar {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        display: inline-block;
        vertical-align: top;
        overflow: hidden;
        margin-right: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .home_user_id {
        font-size: 14px;
        line-height: 24px;
        color: #bdc9ea;
        display: inline-block;
        vertical-align: top;
      }
    }

    .home_user2 {
      margin-left: 5%;
      margin-top: 28px;

      .box_set {
        top: 28px;
      }
    }
    .home_exchange_btn {
      width: 70px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #ac520d;
      background-color: #ffea97;
      background-image: linear-gradient(to bottom, #ffea97, #e5cc52);
      float: right;
      border-radius: 15px;
    }
  }

  .user_points {
    color: #ffffff;
    font-size: 44px;
    text-align: center;
    //margin: 20px auto;
    margin-top: 15px;
    //margin-bottom: 10px;
    font {
      font-size: 12px;
      color: #adc5eb;
    }
  }

  .points_rules_text_box {
    width: 100%;
    text-align: center;

    .points_rules_text {
      color: #bec9ff;
      font-size: 11px;
    }

    .points_rules_text:hover {
      opacity: 0.9;
      cursor: pointer;
    }

    .points_rules_line {
      margin: 0 auto;
      border-bottom: 1px solid #bec9ff;
      width: 45px;
    }
  }

  .exchange_record_btn_wrap {
    text-align: right;
    .exchange_record_btn {
      font-size: 12px;
      color: #d5dbdf;
      display: inline-block;
      text-align: center;
      padding: 5px 10px;
      border: 1px solid #d5dbdf;
      border-radius: 20px;
      margin-right: 12px;
      cursor: pointer;
    }
  }

  .exchange_nav {
    width: 592px;
    margin: 0 auto;
    height: 46px;
    background-color: #ffffff;
    border-bottom: 1px solid #f1f1f1;
    text-align: left;
    .exchange_nav_item {
      display: inline-block;
      margin-top: 10px;
      width: 50px;
      line-height: 36px;
      margin-right: 10px;
      position: relative;
      cursor: pointer;
      text-align: center;
      .exchange_nav_item_title {
        color: #666666;
        font-size: 14px;
      }
    }
    .exchange_nav_item.active,
    .exchange_nav_item:hover {
      .exchange_nav_item_title {
        color: #1a1a1a;
        font-weight: bolder;
      }
      .exchange_nav_item_line {
        position: absolute;
        bottom: -1px;
        background-color: #4366b5;
        width: 15px;
        height: 2px;
        left: 18px;
        border-radius: 1px;
      }
    }
  }
  .exchange_list_wrap {
    height: 452px;
    overflow: scroll;
    background-color: #ffffff;
    -ms-scroll-chaining: chained;
    -ms-content-zooming: zoom;
    -ms-scroll-rails: none;
    -ms-content-zoom-limit-min: 100%;
    -ms-content-zoom-limit-max: 500%;
    -ms-scroll-snap-type: proximity;
    -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: auto;
    .exchange-tips {
      padding-top: 5px;
      width: 592px;
      height: 52px;
      border: 1px solid #ff6c02;
      background-color: #fff0d4;
      color: #ff6c02;
      margin: 0 auto;
      margin-top: 15px;
      font-size: 12px;
      line-height: 20px;
      box-sizing: border-box;
      text-align: center;
      border-radius: 10px;
    }
  }
  .exchange_list_wrap::-webkit-scrollbar {
    display: none;
  }
  .exchange_list {
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    overflow: hidden;

    .exchange_list_title {
      width: 592px;
      margin: 0 auto;
      height: 24px;
      line-height: 24px;
      margin-top: 15px;
      position: relative;
      background-color: rgba(167, 214, 255, 0.42);

      .exchange_list_title_icon {
        vertical-align: top;
        margin-top: 8px;
        margin-right: 5px;
        margin-left: 12px;
        width: 2px;
        height: 7px;
        background: #314a83;
        opacity: 1;
        border-radius: 3px 1px 1px 3px;
        display: inline-block;
      }
      .exchange_list_title_text {
        vertical-align: top;
        display: inline-block;
        color: #333333;
        font-size: 12px;
        font-weight: bolder;
      }
    }

    ul {
      width: 592px;
      margin: 0 auto;
      margin-top: 15px;
      //overflow-y: scroll;
      font-size: 0;
      li:hover {
        //background-color: #fffdeb;
      }
      li {
        display: inline-block;
        width: 130px;
        margin-right: 21px;
        vertical-align: top;
        position: relative;
        text-align: left;

        .exchange_list_item_img_wrap {
          .exchange_list_item_img {
            width: 100%;
            margin: 0 auto;
            text-align: center;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 0px 4px #cccccc;

            img {
              width: 100%;
              height: auto;
            }
          }
        }

        .exchange_list_item_bottom_wrap {
          border-top: 0;
        }
        .exchange_list_item_name {
          white-space: nowrap;
          color: #666666;
          font-size: 12px;
          padding-top: 10px;
          text-align: left;
          font-weight: bolder;
          margin-left: 0px;
        }
        .exchange_list_item_points {
          display: inline-block;
          font-size: 12px;
          transform: scale(0.9);
          color: #ea6e57;
          padding: 5px 0px;
          text-align: left;
          /*margin-left: 8px;*/
          span {
            display: inline-block;
            margin-left: -2px;
            color: #aaaaaa;
          }
        }
        .exchange_btn {
          display: inline-block;
          text-align: center;
          width: 25px;
          height: 12px;
          line-height: 12px;
          font-size: 12px;
          color: #f0af2d;
          border: 1px solid #f0af2d;
          padding: 2px 9px;
          border-radius: 20px;
          margin-bottom: 20px;
          margin-left: 18px;
        }
        .exchange_btn:hover {
          background-color: #f0af2d;
          color: #ffffff;
        }
        .exchange_left_line {
          position: absolute;
          left: 0;
          top: 25px;
          width: 1px;
          height: 80px;
          // background-color: #a6b9d8;
        }
      }
      li:nth-child(4n) {
        margin-right: 0px;
        .exchange_left_line {
          display: none;
        }
      }
      li:hover {
        cursor: pointer;
      }
    }
  }

  .exchange_tips_alert {
    width: 100%;
    height: 100%;
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .exchange_tips_alert_body {
      top: 40%;
      left: 50%;
      padding: 20px;
      position: absolute;
      width: 240px;
      margin-left: -120px;
      border-radius: 10px;
      text-align: center;
      background-color: #ffffff;
      font-size: 14px;
      color: #666666;
    }
  }
}

.exchange_wap {
  // padding-bottom: 15px;
}
</style>